var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccordArrowBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow",
    transform: "translate(-15 229) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 16,
    height: 16,
    transform: "translate(213 15)",
    fill: "#347af0",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow_Icon",
    "data-name": "Arrow Icon",
    d: "M13.4,12.414l4.709-4.7a.889.889,0,0,0-1.26-1.256L11.51,11.784a.888.888,0,0,0-.026,1.226l5.357,5.368a.889.889,0,0,0,1.26-1.256Z",
    transform: "translate(206.194 10.584)",
    fill: "#4B5C68"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordArrowBlack);
export default __webpack_public_path__ + "static/media/accordArrowBlack.fffe1bf775170b561ee7100a1a15a77c.svg";
export { ForwardRef as ReactComponent };